import { ReurbModalidade } from '../../enums';

export enum ProjetoModalidade {
  REURB_E_S = 'REURB_E_S'
}


export type ProjetoModalidadeType = ReurbModalidade | ProjetoModalidade;
